import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import _ from "lodash";
import { ChevronDown, Search } from "lucide-react";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "40px", // Decrease this value to reduce the height
    height: "40px", // Ensure the height is consistently set
    borderRadius: "8px",
    borderColor: state.isFocused ? "#ccc" : "#ccc",
    boxShadow: state.isFocused ? null : null,
    fontSize: "1rem", // Adjust font size here
    "&:hover": {
      borderColor: "#ccc",
    },
  }),
  SingleValue: (provided) => ({
    ...provided,
    fontSize: "1rem", // Adjust font size here
  }),

  valueContainer: (provided) => ({
    ...provided,
    padding: "0 8px",
    height: "40px",
    fontSize: "1rem", // Adjust font size here
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
    fontSize: "1rem", // Adjust font size here
    width: "50px",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "40px",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#ccc" : "#ccc",
    "&:hover": {
      color: "#ccc",
    },
  }),
  menu: (provided) => ({
    ...provided,
    border: "none",
    fontSize: "1rem",
    width: "100%", // Fixed width of the dropdown menu
  }),
  menuList: (provided) => ({
    ...provided,
    border: "none",
    maxHeight: "300px", // Fixed height of the dropdown menu
    overflowY: "auto", // Enable scrolling if the content exceeds the max height
  }),
  option: (base, { isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isSelected
      ? "#2f9da9" // Selected item background
      : isFocused
      ? "#EFFCFB" // Hover background
      : "#fff", // Default background
    color: isSelected ? "#fff" : "#333", // Selected text color
    cursor: "pointer",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#2f9da9", // Change background color of selected values
    color: "white", // Change text color
    borderRadius: "8px", // Optional: rounded corners
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "white", // Ensure text color is visible
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "white",
    borderRadius: "0 8px 8px 0",
    ":hover": {
      backgroundColor: "#d32f2f", // Change background on hover (optional)
      color: "white",
    },
  }),
};

const customDropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <ChevronDown size={16} style={{ color: "#aaa" }} />
      {/* <Search size={16} style={{ color: "#aaa" }} /> */}
      
      {/* Replace arrow with search icon */}
    </components.DropdownIndicator>
  );
};

const SelectComponent = ({
  optionsData,
  placeholder,
  handleValueChange,
  disabled=false,
  isMulti=false,
  isClearable=false,
  value=null
}) => {
  const [selectedOption, setSelectedOption] = useState(value);
  const [options, setOptions] = useState(optionsData);

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  useEffect(() => {
    setOptions(optionsData);
    console.log(optionsData, "optionsData");
  }, [optionsData]);

  const handleChange = (option) => {
    if (!option) {
      setSelectedOption(null);
      handleValueChange(null);
      return;
    }

    if (typeof options === "object" && options.length < 1) {
      setSelectedOption(null);
      handleValueChange(null);
      return;
    }

    setSelectedOption(option);
    handleValueChange(option);
  };

  // const debounce = (func, delay) => {
  //   let timeoutId;
  //   return function (...args) {
  //     if (timeoutId) {
  //       clearTimeout(timeoutId);
  //     }
  //     timeoutId = setTimeout(() => {
  //       func.apply(this, args);
  //     }, delay);
  //   };
  // };

  // const handleInputChange = debounce((inputValue) => {
  //   // Call the API with the input value
  //   if (!_.isEmpty(inputValue) && !_.isEmpty(inputColumn)) {
  //     getSuggestionData(inputColumn, inputValue);
  //   }
  // }, 1000); 
  // Adjust the delay as needed (e.g., 1000 ms)

  return (
    <Select
      value={selectedOption}
      onChange={handleChange}
      options={options}
      isDisabled={disabled}
      placeholder={placeholder}
      styles={customStyles}
      isClearable={isClearable}
      isMulti={isMulti}
      components={{ DropdownIndicator: customDropdownIndicator }} // Use custom dropdown indicator
    />
  );
};

export default SelectComponent;
